import React from "react";
import "./photogallery.scss";
import Globals from "../../api";
import Rightbar from "../../components/Rightbar/Rightbar";
export default class PhotoGallery extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      categoryData: [],
      menuListItems: [],
      meta: [],
      title: [],
      meta_keywords: [],
      meta_description: [],
      Rightbar : [],
      AdData : []
    };
  }
  getAds(){
    const url= Globals.AdConfig;
            fetch(url)
            .then((res) => res.json())
            .then((data) => {
              
                this.setState({
                  AdData : data.AdContents[0].ROS
                })
                
            }) 
            
  } 
      getRightbar(){
        const url= Globals.Rightbar_api+"/news";
        fetch(url)
        .then((res) => res.json())
        .then((data) => {
            
            this.setState({
              Rightbar : data.Contents[0]
            })
        })   
      }    
  componentDidMount() {
    //photo-gallery-new logic
    let url = window.location.pathname;
    if(url == "/photo-gallery")
    url = "/photo-gallery-new";
    url = url.replace("/photo-gallery/", "/photo-gallery-new/");
    //photo-gallery-new logic end
    const categoryListURL = Globals.language_based_api + url;
    fetch(categoryListURL)
      .then((res) => res.json())
      .then((data) => {
        this.setState({
          categoryData: data.Contents,
          menuListItems: data.Contents[2].Items,
          meta: data.Meta,
          title: data.Title,
          meta_keywords: data.Meta.keywords.Attributes.content,
          meta_description: data.Meta.description.Attributes.content,
        });
      });
      this.getRightbar();
      this.getAds();
  }

  render() {
     //next page logic
     let categoryList = this.state.categoryData;
     let NextPageData = categoryList.filter(
       (x) => x.Type == "AutoLoadPage"
     );
     var pageValue = [];
     const Nextpager = NextPageData.map((item) => {
       pageValue = item.PageUrl;
     });
     const nextPage = () => { 
       window.location = pageValue;  
     }
    //next page logic end
    // const nextPage = () => { 
    //   let nextPageUrl = this.state.categoryData;
    //   let index = (nextPageUrl.length==6?3:4);
    //   window.location = nextPageUrl[index].PageUrl;  
    // }
    //let categoryList = this.state.categoryData;
    let menuListData = categoryList.filter(
      (x) => x.Type == "PhotoGalleryNavigation"
    );
   
   let menuItemsvalue = this.state.menuListItems;
    var catsvalue = [];
    //console.log("menuItemsvalueasss", menuItemsvalue);
    const CatArray = menuListData.map((item) => {
      catsvalue = item.Items;
    });
    const menuArr = catsvalue.map((item, i) => (
      <li>
        <a href={item.Url} className={item.Active == true ? "active" : ""}>
          {item.Title}
        </a>
      </li>
    ));
    //  console.log("menuItemsvalue", menuArr);

    let pagelistData = categoryList.filter(
      (x) =>
        x.Type == "MultipleCategoryPhotoGalleryList" ||
        x.Type == "SingleCategoryPhotoGalleryList"
    );
    var itemsvalue = [];
    const pageArr = pagelistData.map((item) => {
      itemsvalue = item.Items;
    });
    // console.log("itemsvalue", itemsvalue);

    let topLargeArr = itemsvalue.slice(0, 1);
    let topArr = itemsvalue.slice(1, 3);
    let listArr = itemsvalue.slice(3);

    const topLargeContent = topLargeArr.map((items) => (
      <a href={items.GalleryUrl || items.Url}>
      <div className="photo_gall_m_block">
      
          <img src={items.Image} />
       
        <div className="photo_gall_capt">
          <a href={items.CategoryUrl} className="photo_category">
            {items.CategoryName}
          </a>
          <h2>
            <a href={items.GalleryUrl || items.Url}>{items.GalleryTitle || items.Title}</a>
          </h2>
        </div>
      </div>
      </a>
    ));

    const topContent = topArr.map((items) => (
      
      <div className="photos_list_block">
        <div className="photo_l_img">
          <a href={items.GalleryUrl || items.Url}>
            <img src={items.Image} />
          </a>
          <label className="photo_l_img_count">
            {items.GalleryImageCount || items.ImageCount}
          </label>
        </div>
        <div className="photo_l_cont">
          <h2>
            <a href={items.GalleryUrl || items.Url}>{items.GalleryTitle || items.Title}</a>
          </h2>


          {(() => {
          if (items.CategoryName) {
            return (
              <a href={items.CategoryUrl} className="photo_category">
            {items.CategoryName }
          </a>
            )
          }
        })()}

          {/* <a href={items.CategoryUrl} className="photo_category">
            {items.CategoryName }
          </a> */}
        </div>
      </div>
      
    ));

    const listData = listArr.map((items, i) => (
      <div className="p_col">
        <div className="photos_list_block">
        <a href={items.GalleryUrl || items.Url}>
          <div className="photo_l_img">
           
              <img src={items.Image} />
           
            <label className="photo_l_img_count">
              {items.GalleryImageCount || items.ImageCount}
            </label>
          </div>
          </a>
          <div className="photo_l_cont">
            <h2>
              <a href={items.GalleryUrl || items.Url}>{items.GalleryTitle || items.Title}</a>
            </h2>

            <a href={items.CategoryUrl} className="photo_category">
              {items.CategoryName}
            </a>
          </div>
        </div>
      </div>
    ));

    return (
      <div>
        <div className="container padding15">
          <div className="row">
            <div className="col">
              <div className="photo_gall_tabs">
                <ul>{menuArr}</ul>
              </div>

              <div className="photos_top_sect">
                <ul>
                  <li>{topLargeContent}</li>
                  <li>{topContent}</li>
                </ul>
              </div>

              <div className="pho_listing">{listData}</div>
              <button style= {{width : "150px" , marginTop : "27px",marginLeft : "370px"}}className="btn btn-block btn-outline-primary" onClick={nextPage}>Load More...</button>
            </div>
            
            <div className="col right_side_bar">
            <Rightbar Rightbar={this.state.Rightbar} googleAds = {this.state.AdData}/>
              {/* <div className="ads_block m-b-15">
                <img src={ads5} />
              </div>
              <Horroscope  Horoscope={this.state.Horoscope}/>
              <div className="ads_block m-b-15 m-t-15">
                <img src={ads5} />
              </div> */}
            
            </div>
          </div>
          
        </div>
      </div>
    );
  }
}
